import { ImportStepState } from "src/app/import/base-import-step.component";
import { ColumnName } from "../import/column-name";
import { AggregationMethod, UIAggregationMethod } from "./aggregation-method";

export class FormCompAggregationSettingsItem {
    public name!: string;
    public columnIx!: number;   //abs ix of the column for this formComp
    public aggregationMethod!: AggregationMethod;
}

export class AggregationSettings {
    public stepState: ImportStepState;
    public formComps: FormCompAggregationSettingsItem[];
    public numericColumns: ColumnName[];
    public outcomeName: string;
}

export class UIFormCompAggregationSettingsItem {
    public name!: string;
    public columnIx!: number;
    public aggregationMethod!: UIAggregationMethod;

    public static fromCore(item: FormCompAggregationSettingsItem): UIFormCompAggregationSettingsItem {
        const uiItem = new UIFormCompAggregationSettingsItem();
        uiItem.name = item.name;
        uiItem.columnIx = item.columnIx;
        uiItem.aggregationMethod = UIAggregationMethod.fromCore(item.aggregationMethod);
        return uiItem;
    }

    public static toCore(uiItem: UIFormCompAggregationSettingsItem): FormCompAggregationSettingsItem {
        const item = new FormCompAggregationSettingsItem();
        item.name = uiItem.name;
        item.columnIx = uiItem.columnIx;
        item.aggregationMethod = UIAggregationMethod.toCore(uiItem.aggregationMethod);
        return item;
    }
}

export class UIAggregationSettings {
    public stepState: ImportStepState;
    public formComps: UIFormCompAggregationSettingsItem[];
    public numericColumns: ColumnName[];
    public outcomeName: string;

    public static fromCore(settings: AggregationSettings): UIAggregationSettings {
        const uiSettings = new UIAggregationSettings();
        uiSettings.stepState = settings.stepState;
        uiSettings.formComps = settings.formComps?.map(fc => UIFormCompAggregationSettingsItem.fromCore(fc));
        uiSettings.numericColumns = settings.numericColumns;
        uiSettings.outcomeName = settings.outcomeName;
        return uiSettings;
    }

    public static toCore(uiSettings: UIAggregationSettings): AggregationSettings {
        const settings = new AggregationSettings();
        settings.stepState = uiSettings.stepState;
        settings.formComps = uiSettings.formComps?.map(fc => UIFormCompAggregationSettingsItem.toCore(fc));
        settings.numericColumns = uiSettings.numericColumns;
        settings.outcomeName = uiSettings.outcomeName;
        return settings;
    }
}